(function () {
    "use strict";

    angular.module("sempraWebapp").controller("SavingsGroupCreateController", SavingsGroupCreateController);

    /** @ngInject */
    function SavingsGroupCreateController(
        $scope,
        $state,
        $stateParams,
        $translate,
        $timeout,
        $mdDialog,
        userGroupActions,
        sempraUsersActions,
        dialogsService,
        hostProtocol,
        hostDomain,
        Upload
    ) {
        var vm = this;
        var newGroupId;

        // State
        vm.isEditMode = !!$stateParams.id;
        vm.groupId = $stateParams.id;
        vm.isLoading = false;
        vm.searchUserValidation = false;

        // Form data
        vm.groupName = '';
        vm.groupType = 'SAVINGS';

        // Users management
        vm.groupUsers = [];
        vm.searchUserText = '';
        vm.usersPage = 1;
        vm.usersPageSize = 10;
        vm.usersPageOptions = [5, 10, 15];
        vm.usersTotal = 0;
        vm.usersOrderBy = 'user.firstName';
        vm.usersOrder = 'asc';
        vm.usersPromise = null;
        vm.pagerTranslations = {
            page: $translate.instant('GRID_PAGER_PAGE'),
            rowsPerPage: $translate.instant('GRID_PAGER_ROWS_PER_PAGE'),
            of: $translate.instant('GRID_PAGER_PAGE_OF')
        };

        // Unknown users from CSV upload
        vm.unknownUserList = [];

        // Functions
        vm.createUpdateGroup = createUpdateGroup;
        vm.addUserToGroup = addUserToGroup;
        vm.removeUserFromGroup = removeUserFromGroup;
        vm.uploadFile = uploadFile;
        vm.showListOfUnknownUsers = showListOfUnknownUsers;
        vm.onUsersPageChange = onUsersPageChange;
        vm.onUsersOrderChange = onUsersOrderChange;
        vm.goBack = goBack;

        // Title
        vm.title = vm.isEditMode 
            ? $translate.instant('BREAD_CRUMBS_EDIT_USER_GROUP') 
            : $translate.instant('SAVINGS_CREATE_GROUP');

        init();

        function init() {
            if (vm.isEditMode) {
                loadGroup();
            }
            $scope.$on('$destroy', onDestroy);
        }

        function onDestroy() {
            vm.groupUsers = [];
        }

        function loadGroup() {
            vm.isLoading = true;
            userGroupActions.getUserGroupById(vm.groupId).then(function (groupJson) {
                vm.groupName = groupJson.name;
                vm.groupType = groupJson.groupType || 'SAVINGS';
                refreshGroupUsers();
                vm.isLoading = false;
            }).catch(function (error) {
                console.error('Error loading group:', error);
                vm.isLoading = false;
            });
        }

        function refreshGroupUsers() {
            vm.usersPromise = userGroupActions.getActiveUsersForUserGroup(
                vm.groupId,
                vm.usersPage - 1,
                vm.usersPageSize,
                vm.usersOrderBy,
                vm.usersOrder
            ).then(function (usersJson) {
                vm.groupUsers = usersJson.content || [];
                vm.usersTotal = usersJson.totalElements || 0;
            });
        }

        function createUpdateGroup($event) {
            vm.groupName = vm.groupName.trim();
            if (vm.groupName === '') {
                return;
            }

            if (vm.isEditMode) {
                userGroupActions.updateUserGroup(vm.groupId, vm.groupName).then(onGroupSaveUpdateSuccess);
            } else {
                userGroupActions.createUserGroup(vm.groupName, 'SAVINGS').then(onGroupSaveUpdateSuccess);
            }

            if ($event && $event.target) {
                $event.target.blur();
            }
        }

        function onGroupSaveUpdateSuccess(responseId) {
            newGroupId = responseId;
            if (!vm.isEditMode) {
                vm.groupId = responseId;
                vm.isEditMode = true;
                vm.title = $translate.instant('BREAD_CRUMBS_EDIT_USER_GROUP');
            }
        }

        function addUserToGroup(text) {
            if ($scope.searchUserForm && $scope.searchUserForm.savingsUserId) {
                $scope.searchUserForm.savingsUserId.$setUntouched();
            }
            // For SAVINGS groups, search by firstName (ID)
            sempraUsersActions.searchSavingsUsers(text).then(function(val) {
                if (val.length > 0) {
                    var savingsUserId = val[0].userId;
                    if (!checkIfUserIsInGroup(savingsUserId)) {
                        userGroupActions.addUserToUserGroup(vm.groupId, savingsUserId).then(function () {
                            vm.searchUserText = '';
                            refreshGroupUsers();
                        });
                    } else {
                        showSearchUserValidation();
                        hideSearchUserValidation();
                    }
                } else {
                    dialogsService.showOkDialog('MISSING_USER', 'USER_NOT_ON_LIST').then();
                }
            });
        }

        function checkIfUserIsInGroup(userId) {
            for (var i = 0; i < vm.groupUsers.length; i++) {
                if (vm.groupUsers[i].user.id === userId) {
                    return true;
                }
            }
            return false;
        }

        function showSearchUserValidation() {
            vm.searchUserValidation = true;
        }

        function hideSearchUserValidation() {
            $timeout(function() {
                vm.searchUserValidation = false;
            }, 3000);
        }

        function removeUserFromGroup(groupUser) {
            dialogsService.showConfirmDialog('DELETE_USER', 'DELETE_USER_FROM_USER_GROUP_QUESTION', 'OK').then(function () {
                userGroupActions.removeUserFromUserGroup(groupUser.id).then(function () {
                    refreshGroupUsers();
                });
            });
        }

        function uploadFile(file, errFiles) {
            /* eslint-disable */
            $scope.f = file;
            $scope.errFile = errFiles && errFiles[0];
            var id = vm.groupId || newGroupId;
            if (file) {
                file.upload = Upload.upload({
                    url: hostProtocol + '://' + hostDomain + '/api/userGroups/' + id,
                    data: {file: file}
                });

                file.upload.then(function (response) {
                    if (response.data.length > 0) {
                        vm.unknownUserList = unknownUser(response.data);
                    }
                    // Refresh user group
                    userGroupActions.getUserGroupById(id).then(function (groupJson) {
                        vm.groupName = groupJson.name;
                    });
                    refreshGroupUsers();
                    $timeout(function () {
                        file.result = response.data;
                    });
                }, function (response) {
                    if (response.status > 0) {
                        $scope.errorMsg = response.status + ': ' + response.data;
                    }
                }, function (evt) {
                    file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });
            }
            /* eslint-enable */
        }

        function unknownUser(list) {
            var data = [];
            var user = {};
            list.forEach(function(item, index) {
                if (item.length > 0) {
                    user = {
                        id: index + 1,
                        email: item
                    };
                    data.push(user);
                }
            });
            return data;
        }

        function showListOfUnknownUsers(ev) {
            $mdDialog.show({
                controller: unknownListOfUsersController,
                controllerAs: 'vm',
                bindToController: true,
                templateUrl: 'app/createUpdateUserGroup/uknownUserListModal.html',
                /* eslint-disable */
                parent: angular.element(document.body),
                /* eslint-enable */
                targetEvent: ev,
                locals: { userList: vm.unknownUserList },
                clickOutsideToClose: true
            });
        }

        function unknownListOfUsersController($mdDialog) {
            /* eslint-disable */
            var that = this;
            /* eslint-enable */
            that.closeDialog = function() {
                $mdDialog.hide();
            };
        }

        function onUsersPageChange(page, limit) {
            vm.usersPage = page;
            vm.usersPageSize = limit;
            refreshGroupUsers();
        }

        function onUsersOrderChange(order) {
            if (order.indexOf('-') > -1) {
                vm.usersOrder = 'desc';
                vm.usersOrderBy = order.substring(1);
            } else {
                vm.usersOrder = 'asc';
                vm.usersOrderBy = order;
            }
            refreshGroupUsers();
        }

        function goBack() {
            $state.go('app.savings', { tab: 1 });
        }
    }
})();
